/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_PendingInputs */

const cs_settings_calendar_pending = /** @type {(inputs: Settings_Calendar_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeká se na dokončení přihlášení…`)
};

const en_settings_calendar_pending = /** @type {(inputs: Settings_Calendar_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for you to finish sign-in…`)
};

/**
* | output |
* | --- |
* | "Waiting for you to finish sign-in…" |
*
* @param {Settings_Calendar_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_pending = /** @type {((inputs?: Settings_Calendar_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_pending(inputs)
	return cs_settings_calendar_pending(inputs)
});